/**
 * OWASP A02.3: access token apenas em memoria (sem localStorage).
 * Api usa getAccessToken() no interceptor.
 */
let accessToken: string | null = null;
let userData: { primeiro_nome: string; group: string } | null = null;

export function setAccessToken(token: string | null): void {
  accessToken = token;
}

export function getAccessToken(): string | null {
  return accessToken;
}

export function setUserData(data: { primeiro_nome: string; group: string } | null): void {
  userData = data;
}

export function getUserData(): { primeiro_nome: string; group: string } | null {
  return userData;
}

export function clearAuth(): void {
  accessToken = null;
  userData = null;
}
